import React from 'react';
import { motion } from 'framer-motion';
import { Headphones, BookOpen } from 'lucide-react';
export function IncludesSection() {
  return <section className="py-12 px-4 bg-matrix-bg" data-id="element-102">
      <div className="max-w-4xl mx-auto" data-id="element-103">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-matrix-orange mb-10 text-center" data-id="element-104">
          Qué incluye exactamente
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-105">
          {/* Audiobook Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-matrix-surface p-8 rounded-lg border border-matrix-dim hover:border-matrix-primary/30 transition-colors" data-id="element-106">
            <Headphones className="w-10 h-10 text-matrix-primary mb-6" data-id="element-107" />
            <h3 className="text-xl font-bold text-matrix-text mb-2" data-id="element-108">
              1) Audio Libro (1 hora)
            </h3>
            <p className="text-matrix-muted" data-id="element-109">
              14 tracks, narración lista para escuchar como un ritual diario.
            </p>
          </motion.div>

          {/* Workbook Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-matrix-surface p-8 rounded-lg border border-matrix-dim hover:border-matrix-primary/30 transition-colors" data-id="element-110">
            <BookOpen className="w-10 h-10 text-matrix-primary mb-6" data-id="element-111" />
            <h3 className="text-xl font-bold text-matrix-text mb-2" data-id="element-112">
              2) Libro de Trabajo PDF
            </h3>
            <p className="text-matrix-muted" data-id="element-113">
              Contrato Anti-Matrix, tracker 30 días, fricciones, reemplazos,
              checklist semanal.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}